import React from 'react';

const ThemesMenu = () => {
  return (
    <div>ThemesMenu</div>
  );
};

export default ThemesMenu;
